import React from "react"

import { useAppSelector } from "@/store"
import { ViewType, selectLoginType } from "@/stores/login_slice"
import { Box } from "@chakra-ui/react"
import ChangeUserCom from "./change_user"
import { useProcessUrlParams } from "./login_hook"
import LoginCom from "./login_view"
import { PCLoginView } from "./pc_view"
import SetKCPwdView from "./set_kc_pwd_view"
import BackgroundCarousel from "@/widgets/Swiper"
import SetPhoneVerifyView from "./set_phone_verify"
import ImgCodeVerify from "./img_code_verify"
import StopResumePwdVerify from "./stop_resume_pwd_verify"
import ChangePasswordReminderDialog from "./change_password_reminder_dialog"

const LoginPage: React.FC = () => {
  const viewType = useAppSelector(selectLoginType)

  // 处理登录连接参数
  useProcessUrlParams()

  return (
    <>
      <BackgroundCarousel />
      <Box width="100vw" height="100vh" position="relative" zIndex={1}>
        {/* 登录 */}
        {viewType === ViewType.login && <LoginCom />}
        {/* 切换用户 */}
        {viewType === ViewType.selectUser && <ChangeUserCom />}
        {/* 设置企业登录密码 */}
        {viewType === ViewType.setKCPwd && <SetKCPwdView />}
        {/* 设置手机、验证码 */}
        {viewType === ViewType.setPhoneVerify && <SetPhoneVerifyView />}
        {/* 图片验证码  校验弹窗 */}
        {viewType === ViewType.imgcodeVerify && <ImgCodeVerify />}
        {/* 云电脑重启/关机  密码校验弹窗 */}
        {viewType === ViewType.stopResumeVerify && <StopResumePwdVerify />}
        {/* 个人用户 */}
        {viewType === ViewType.pcLogin && <PCLoginView />}
        {/* 修改初始密码提示弹窗 */}
        <ChangePasswordReminderDialog />
      </Box>
    </>
  )
}

export default LoginPage
